import { z } from 'zod'

/**
 * Schema base para reservas (sin validaciones de refinamiento)
 */
const reservaSchemaBase = z.object({
  // Cliente (opcional)
  client_id: z.string().optional(),
  
  // Información del huésped
  guest_name: z.string().min(1, 'El nom de l\'hoste és obligatori'),
  guest_email: z.string().email('Email invàlid').optional().or(z.literal('')),
  guest_phone: z.string().optional(),
  
  // Fechas
  data_entrada: z.string().min(1, 'La data d\'entrada és obligatòria'),
  data_sortida: z.string().min(1, 'La data de sortida és obligatòria'),
  
  // Habitación
  room_id: z.string().min(1, 'Has de seleccionar una habitació'),
  
  // Ocupación
  num_adults: z.number().min(1, 'Mínim 1 adult'),
  num_nens: z.number().min(0).default(0),
  
  // Precios
  preu_total: z.number().min(0).default(0),
  deposit: z.number().min(0).default(0),
  
  // Otros
  hora_arribada: z.string().optional(),
  canal: z.string().default('DIRECT'),
  notes_client: z.string().optional(),
  notes_internes: z.string().optional(),
})

/**
 * Schema para crear/editar reservas (con validación de fechas)
 */
export const reservaSchema = reservaSchemaBase.refine((data) => data.data_sortida > data.data_entrada, {
  message: 'La data de sortida ha de ser posterior a la data d\'entrada',
  path: ['data_sortida'],
})

export type ReservaFormData = z.infer<typeof reservaSchema>

/**
 * Schema para editar reservas (todos los campos opcionales, sin room_id)
 */
export const editReservaSchema = reservaSchemaBase.omit({ room_id: true }).partial()
